import '@polymer/polymer/polymer-legacy.js';
import '@polymer/paper-styles/color.js';
import '@polymer/paper-styles/shadow.js';
import '@polymer/font-roboto/roboto.js';
import '@polymer/paper-styles/shadow.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
Polymer({
  _template: html`
    <style>
      :host {
        --primary-text-color: var(--paper-grey-900);
        --font-size: 12pt;
        --font-family: Roboto;
        --background-color: white;
        --color: var(--primary-text-color);
        --progress-background-color: var(--paper-red-500);
        --progress-color: var(--primary-text-color);
        --progress-secondary-background-color: var(--paper-amber-500);
        --progress-secondary-color: var(--primary-text-color);
        --progress-border-color: var(--progress-background-color);
        --progress-secondary-border-color: var(--progress-secondary-background-color);

        position: relative;
        display: block;
        height: 48px;
        width: 100%;
        background-color: var(--background-color);
        box-sizing: border-box;
        border-radius: 64px;
        color: var(--color);
        @apply (--shadow-elevation-2dp);
        font-family: var(--font-family);
        font-size: var(--font-size);
      }
      :host,
      .progress,
      .progressContent {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }
      .progress,
      .progressContent {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        box-sizing: border-box;
      }
      .progress {
        background-color: var(--progress-background-color);
        color: var(--progress-color);
        /* border-radius: inherit; */
        @apply --progress;
      }
      .progress.secondary {
        background-color: var(--progress-secondary-background-color);
        color: var(--progress-secondary-color);
        @apply --progress-secondary;
      }
      .progress:hover {
        border: 1px solid var(--progress-border-color);
      }
      .progress.secondary:hover {
        border: 1px solid var(--progress-secondary-border-color);
      }
      .faded {
        opacity: 0.4;
      }
      .keepCursorDefault:hover {
        cursor: default;
      }
    </style>
    <span class$="[[getBaseLabelClass(label)]] keepCursorDefault">[[label]]</span>
    <div class="progress keepCursorDefault" style$="width: [[width]]%;">
      <div class="progressContent" style$="width: [[contentWidth]]%;">
        <span>[[label]]</span>
      </div>
    </div>
    <div class="progress secondary keepCursorDefault" style$="width: [[secondaryWidth]]%;">
      <div class="progressContent" style$="width: [[secondaryContentWidth]]%;">
        <span>[[label]]</span>
      </div>
    </div>
  `,

  is: 'progress-bar',

  properties: {
    max: {
      type: Number,
      value: 100,
      observer: 'updateBoth'
    },
    min: {
      type: Number,
      value: 0,
      observer: 'updateBoth'
    },
    value: {
      type: Number,
      value: 0,
      observer: 'updateProgress'
    },
    secondaryValue: {
      type: Number,
      value: 0,
      observer: 'updateSecondaryProgress'
    },
    label: {
      type: String
    }
  },

  ready: function () {},

  getBaseLabelClass: function (label) {
    return label == 0 ? 'faded' : '';
  },

  updateBoth: function () {
    this.updateProgress();
    this.updateSecondaryProgress();
  },

  updateProgress: function () {
    this.width = ((this.value - this.min) / this.max) * 100;
    this.contentWidth = 10000 / this.width;
  },

  updateSecondaryProgress: function () {
    this.secondaryWidth = ((this.secondaryValue - this.min) / this.max) * 100;
    this.secondaryContentWidth = 10000 / this.secondaryWidth;
  }
});
